import { useCallback } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Hook para exportar datos a un archivo Excel (.xlsx).
 * Devuelve una función exportarAExcel(datos, columnas, nombreArchivo).
 */
export const useExcelExport = () => {
  /**
   * Exporta datos a un archivo Excel
   * @param {Array<Object>} data - Datos de la tabla.
   * @param {Array<{ field: string, header: string }>} columnas - Columnas a exportar.
   * @param {string} nombreArchivo - Nombre del archivo .xlsx (sin extensión).
   */
  const exportarAExcel = useCallback((data, columnas, nombreArchivo = 'Reporte') => {
    if (!Array.isArray(data) || data.length === 0) {
      console.warn('No hay datos para exportar.');
      return;
    }

    const datosProcesados = data.map((fila) => {
      const nuevaFila = {};
      columnas.forEach(({ field, header }) => {
        const valor = field.split('.').reduce((acc, key) => acc?.[key], fila);
        nuevaFila[header] = valor !== undefined ? valor : '';
      });
      return nuevaFila;
    });

    const hoja = XLSX.utils.json_to_sheet(datosProcesados);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, 'Datos');

    const buffer = XLSX.write(libro, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, `${nombreArchivo}.xlsx`);
  }, []);

  return { exportarAExcel };
};